<template>
  <div class="float-left q-mr-md q-mb-md">
    <q-btn
      :loading="loading.ticketTransfer"
      :disable="disabled"
      :color="SET_COLOR_BUTTON.primary"
      :label="$t('button.exchangeTicket')"
      type="a"
      @click="dialogTicketTransferModel = true"
    />
    <q-tooltip
      v-if="disabled"
      self="top middle"
      anchor="bottom middle"
    >
      {{ getTooltipTranslationByVoucherOrTicket() }}
    </q-tooltip>
    <dialog-ticket-transfer
      v-model="dialogTicketTransferModel"
      :ticket="ticket"
      @confirm-transfer="handleTransferTicket($event)"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'TransferTicketButton',
    components: {
      DialogTicketTransfer: () => import('components/dialog/ticketTransfer/dialog'),
    },
    props: {
      ticket: {
        type: Object,
        required: true,
        default: null,
      },
      disabled: {
        type: Boolean,
        required: true,
        default: false,
      },
      hasTicket: {
        type: Boolean,
        required: false,
        default: false,
      },
      hasVoucher: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data: () => ({
      dialogTicketTransferModel: false,
    }),
    computed: {
      ...mapGetters('myTicket', [
        'loading',
      ]),
    },
    methods: {
      ...mapActions('myTicket', [
        'transferTicket',
      ]),
      async handleTransferTicket(payload) {
        this.dialogTicketTransferModel = false;
        try {
          const response = await this.transferTicket({
            ticketId: this.ticket.id,
            priceId: payload.selectedPriceToTransfer.id,
          });
          this.$emit('change-ticket', response);
          this.$q.notify({
            message: this.$t('alert.ticketTransfer.success'),
            timeout: 3000,
            color: 'positive',
            icon: 'check',
          });
        } catch (error) {
          this.toastError(error);
        }
      },
      getTooltipTranslationByVoucherOrTicket() {
        if (this.hasTicket && this.hasVoucher) {
          return this.$t('text.ticketTransfer.alreadyTransferredTicketVoucher');
        }

        if (this.hasTicket) {
          return this.$t('text.ticketTransfer.alreadyTransferredTicket');
        }

        return this.$t('text.ticketTransfer.alreadyTransferredVoucher');
      },
    },
  };
</script>
